import { CustomDialog } from '@aibees/shared/components';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomDialog)`
  .MuiDialog-paper {
    background: ${(p) => p.theme.palette.grey[200]};
    padding: 0 !important;
  }
  .MuiDialogActions-root {
    display: none;
  }
`;

export const Content = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing(1.5)};
  background: ${(p) => p.theme.palette.common.white};
  border: 1px solid ${(p) => p.theme.palette.grey[300]};
  border-radius: ${(p) => p.theme.spacing(2)};
  padding: ${(p) => p.theme.spacing(2)};
`;

export const SortableContent = styled(Stack)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: ${(p) => p.theme.spacing(3)};
  background: ${(p) => p.theme.palette.common.white};
  border: 1px solid ${(p) => p.theme.palette.primary[100]};
  border-radius: ${(p) => p.theme.spacing(1)};
  padding: ${(p) => p.theme.spacing(1.25)};
`;
